export default __webpack_public_path__ + "static/media/sidebar-settings.25a20297.svg";